/* eslint-disable import/no-cycle */
/* eslint-disable no-else-return */
import { appContextStore } from "../../../common/redux/appContext";
import { MembershipLevelsEnum } from "../enums/membershipLevelsEnum";
import { membershipContentStore } from "../../../common/redux/membershipContent";
import { IInitialProduction } from "../../redux/ProductionReducer/ProductionReducer.types";
import { validateRiskProtection } from ".";

export const checkMembershipQualifications = (
  commission: IInitialProduction[],
  premium: IInitialProduction[],
  income: IInitialProduction[],
  commissionTotal: number,
  premiumTotal: number,
  incomeTotal: number,
  commissionRiskProtection: number,
  premiumRiskProtection: number,
  incomeRiskProtection: number,
  incomeNewBusiness: number
) => {
  const { country } = appContextStore.getState();

  const { productionStep, membershipTypeStep } =
    membershipContentStore.getState();

  const { highestValidLevel, highestLevel } = validateRiskProtection(
    commission,
    premium,
    income,
    commissionTotal,
    premiumTotal,
    incomeTotal,
    commissionRiskProtection,
    premiumRiskProtection,
    incomeRiskProtection,
    incomeNewBusiness
  );

  if (country.unlimitedProductionIsAllowed) {
    if (highestLevel === MembershipLevelsEnum.TOT) {
      return {
        display: true,
        levelImgSrc: membershipTypeStep.toTMembershipLevel.logoImageUrl,
        level: MembershipLevelsEnum.TOT,
        notificationText: productionStep.membershipLevelsBannerToTNotification,
      };
    } else if (highestLevel === MembershipLevelsEnum.COT) {
      return {
        display: true,
        levelImgSrc: membershipTypeStep.coTMembershipLevel.logoImageUrl,
        level: MembershipLevelsEnum.COT,
        notificationText: productionStep.membershipLevelsBannerCoTNotification,
      };
    } else if (highestLevel === MembershipLevelsEnum.MDRT) {
      return {
        display: true,
        levelImgSrc: membershipTypeStep.mdrtMembershipLevel.logoImageUrl,
        level: MembershipLevelsEnum.MDRT,
        notificationText: productionStep.membershipLevelsBannerMdrtNotification,
      };
    }
  } else if (highestValidLevel === MembershipLevelsEnum.TOT) {
    return {
      display: true,
      levelImgSrc: membershipTypeStep.toTMembershipLevel.logoImageUrl,
      level: MembershipLevelsEnum.TOT,
      notificationText: productionStep.membershipLevelsBannerToTNotification,
    };
  } else if (highestValidLevel === MembershipLevelsEnum.COT) {
    return {
      display: true,
      levelImgSrc: membershipTypeStep.coTMembershipLevel.logoImageUrl,
      level: MembershipLevelsEnum.COT,
      notificationText: productionStep.membershipLevelsBannerCoTNotification,
    };
  } else if (highestValidLevel === MembershipLevelsEnum.MDRT) {
    return {
      display: true,
      levelImgSrc: membershipTypeStep.mdrtMembershipLevel.logoImageUrl,
      level: MembershipLevelsEnum.MDRT,
      notificationText: productionStep.membershipLevelsBannerMdrtNotification,
    };
  }
  return {
    display: true,
    levelImgSrc: "",
    level: " ",
    notificationText: " ",
  };
};

export default {};
